import { DocumentType } from '@/shared/lib';

export interface ApprovalDetailConfig {
  cardTitle: string;
  codeFieldLabel: string;
  showTitleField: boolean;
  viewButtonLabel: string;
  approveOptionLabel: string;
  rejectOptionLabel: string;
  rejectPlaceholder: string;
  rejectConfirmTitle: string;
  hasTrainingStep: boolean;
  rejectSuccessTitle: string;
  rejectErrorMessage: string;
  listTabType: DocumentType;
}

export const APPROVAL_DETAIL_CONFIG: Record<DocumentType, ApprovalDetailConfig> = {
  [DocumentType.DOCUMENT]: {
    cardTitle: 'Documento para Aprovação',
    codeFieldLabel: 'Documento',
    showTitleField: false,
    viewButtonLabel: 'Ver documento',
    approveOptionLabel: 'Aprovar documento',
    rejectOptionLabel: 'Reprovar documento',
    rejectPlaceholder: 'Explique porque o documento foi reprovado',
    rejectConfirmTitle: 'Tem certeza que deseja reprovar o documento?',
    hasTrainingStep: true,
    rejectSuccessTitle: 'Documento reprovado',
    rejectErrorMessage: 'Erro ao reprovar documento. Tente novamente',
    listTabType: DocumentType.DOCUMENT,
  },
  [DocumentType.REGISTRATION]: {
    cardTitle: 'Registro para Aprovação',
    codeFieldLabel: 'Registro',
    showTitleField: true,
    viewButtonLabel: 'Ver registro',
    approveOptionLabel: 'Aprovar registro',
    rejectOptionLabel: 'Reprovar registro',
    rejectPlaceholder: 'Explique o que deve ser editado no registro.',
    rejectConfirmTitle: 'Tem certeza que deseja reprovar o registro?',
    hasTrainingStep: false,
    rejectSuccessTitle: 'Registro reprovado',
    rejectErrorMessage: 'Erro ao reprovar registro. Tente novamente',
    listTabType: DocumentType.REGISTRATION,
  },
};

const isDocumentType = (value: unknown): value is DocumentType =>
  typeof value === 'string' && Object.prototype.hasOwnProperty.call(APPROVAL_DETAIL_CONFIG, value);

export const getApprovalDetailConfig = (documentType?: string): ApprovalDetailConfig =>
  isDocumentType(documentType)
    ? APPROVAL_DETAIL_CONFIG[documentType]
    : APPROVAL_DETAIL_CONFIG[DocumentType.DOCUMENT];
